$(document).ready(function () {
    const gtmHelpers = new GoogleTagManagerHelpers();
    let touchStartX = 0;
    let touchEndX = 0;

    
    $(document).on('click', '.size-input-radio', function () {
        const productTitle = $(this).data('title');
        $(document).trigger('gtm-datalayer', {
            path: 'general:click',
            custom: {
                custom_type: gtmHelpers.types.card,
                custom_title: gtmHelpers.formatProductTitle(productTitle),
            }
        });
    });

    $(document).on('click', '.color-input-radio', function () {
        const productTitle = $(this).data('title');
        $(document).trigger('gtm-datalayer', {
            path: 'general:click',
            custom: {
                custom_type: gtmHelpers.types.card,
                custom_title: gtmHelpers.formatString(productTitle),
            }
        });
    });
    
    $(document).on('click', '#size-chart', function () {
        $(document).trigger('gtm-datalayer', {
            path: 'general:click',
            custom: {
                custom_type: gtmHelpers.types.button,
                custom_title: 'size-chart',
            }
        });
    });

    $(document).on('click', '.product__modal-opener--image', function () {
        if (window.innerWidth > 768) {
            const $productImage = $(this).find('.product__media-image');
            const productImagePosition = $productImage.data('position');
            $(document).trigger('gtm-datalayer', {
                path: 'general:click',
                custom: {
                    custom_type: gtmHelpers.types.card,
                    custom_title: `photo-${productImagePosition}`
                }
            });
        }
    });

    $(document).on('touchstart', '.product__modal-opener--image', function (event) {
        if (window.innerWidth < 768) {
            touchStartX = event.changedTouches[0].screenX;
        }
    });

    $(document).on('touchend', '.product__modal-opener--image', function (event) {
        if (window.innerWidth < 768) {
            touchEndX = event.changedTouches[0].screenX;
            if (touchEndX !== touchStartX) {
                const $productImage = $(this).find('.product__media-image');
                const productImagePosition = $productImage.data('position');
                $(document).trigger('gtm-datalayer', {
                    path: 'general:interact',
                    custom: {
                        custom_type: 'slide',
                        custom_title: `photo-${productImagePosition}`
                    }
                });
            }
        }
    });

    $(document).on('click', '#pdp-show-more-button', function () {
        const gtmTitle = $(this).text() === $(this).data('textToggle') ? $(this).data('text') : $(this).data('textToggle');
        $(document).trigger('gtm-datalayer', {
            path: 'general:click',
            custom: {
                custom_type: gtmHelpers.types.button,
                custom_title: gtmHelpers.formatString(gtmTitle)
            }
        });
    });

    $(document).on('click', '#konfidency-reviews-container .sort-field', function (e) {
        const filterName = $(this).closest('.sort').find('span').text()
		if (filterName && this.value) {
			$(document).trigger('gtm-datalayer', {
				path: 'general:click',
				custom: {
					custom_type: gtmHelpers.types.filter,
					custom_title: `${gtmHelpers.formatString(filterName)}:${gtmHelpers.formatString($(this).find(`option[value="${this.value}"]`).text())}`
				}
			});
		}
    });

    
});
